import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Droplets, ShieldCheck } from 'lucide-react';

export default function Header({ title, subtitle }) {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-30 border-b border-slate-200/60 bg-white/80 backdrop-blur-xl md:top-16">
      <div className="app-container pb-3 pt-4">
        <div className="flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 md:hidden"
            data-testid="header-logo"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-white shadow-soft">
              <Droplets size={20} />
            </span>
            <div className="text-left leading-tight">
              <p className="font-heading text-sm font-extrabold text-ink">Águas Vivas</p>
              <p className="text-[11px] font-medium text-ink-faint">Caratinga · MG</p>
            </div>
          </button>
          <div className="hidden md:block" />
          <button
            onClick={() => navigate('/admin')}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-white text-ink-soft transition-colors duration-200 hover:text-primary"
            data-testid="header-admin-btn"
            aria-label="Área administrativa"
          >
            <ShieldCheck size={18} />
          </button>
        </div>
        {title && (
          <div className="mt-3">
            <h1 className="font-heading text-2xl font-extrabold tracking-tight text-ink md:text-3xl">{title}</h1>
            {subtitle && <p className="mt-0.5 text-sm text-ink-soft">{subtitle}</p>}
          </div>
        )}
      </div>
    </header>
  );
}
